export default "__VITE_ASSET__Bj4omg2K__"